import { useStyles } from './styles'

type AppBackdropProps = {
  styles?: React.CSSProperties
  onClick?: () => void
}

export const AppBackdrop = (props: AppBackdropProps) => {
  const { classes } = useStyles()
  const { styles, onClick } = props
  return (
    <div
      className={classes.root}
      style={styles}
      onClick={onClick}
    />
  )
}
